import React, { useState } from "react";
import { Box, Typography, Button, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ChatBot = ({ chatOpen, setChatOpen }) => {
  const [userMessage, setUserMessage] = useState('');

  const messages = [
    { id: 1, sender: 'user', text: 'Hola ChatBot!' },
    { id: 2, sender: 'bot', text: '¡Hola! ¿En qué puedo ayudarte?' },
    { id: 3, sender: 'user', text: 'Necesito ayuda con mi cuenta.' },
    { id: 4, sender: 'bot', text: '¡Claro! ¿Qué problema tienes?' },
  ];

  const handleSendMessage = () => {
    if (userMessage.trim()) {
      // Añadir el mensaje a la lista de mensajes
      messages.push({ id: Date.now(), sender: 'user', text: userMessage.trim() });
  
      // Resetear el campo de mensaje
      setUserMessage('');
  
      // Aquí puedes añadir la lógica para que el bot responda automáticamente, si lo deseas.
    }
  };
  
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 50,
        right: 90,
        width: chatOpen ? 400 : 0,  // Controla el ancho basado en si está abierto o no
        height: chatOpen ? 500 : 0, // Controla el alto basado en si está abierto o no
        overflow: "hidden",
        transition: "all 0.3s",  // Transición suave
        boxShadow: 3,
        bgcolor: "background.paper",
      }}
    >
      {chatOpen  && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            padding: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">ChatBot</Typography>
            <IconButton size="small" onClick={() => setChatOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box flex={1} bgcolor="grey.200" mt={2}>
            {messages.map(message => (
                <Box key={message.id} sx={{ textAlign: message.sender === 'bot' ? 'left' : 'right', p: 1 }}>
                {message.text}
                </Box>
            ))}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TextField 
                fullWidth 
                variant="outlined" 
                value={userMessage} 
                onChange={e => setUserMessage(e.target.value)} 
                placeholder="Escribe un mensaje..."
            />
            <Button variant="contained" color="primary" onClick={handleSendMessage} sx={{ ml: 1 }}>
                Enviar
            </Button>
            </Box>
        </Box>
      )}
    </Box>
  );
};

export default ChatBot;
